import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FieldValueBaseFragment = { __typename?: 'AssetFieldValue', id: string, fieldType: Types.FieldTypeEnum, valueLength?: number | null, isValueTrimmed?: boolean | null, fieldDefinition: { __typename?: 'ProjectFieldDefinition', id: string } };

export const FieldValueBase = /*#__PURE__*/ gql`
    fragment FieldValueBase on AssetFieldValue {
  id
  fieldType
  valueLength
  isValueTrimmed
  fieldDefinition {
    id
  }
}
    ` as unknown as DocumentNode<FieldValueBaseFragment, unknown>;

        

        
export const useFieldValueBaseFragment = (
  input: string | Omit<UseFragmentOptions<FieldValueBaseFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetFieldValue' } };
    return input;
  })();

  return useFragment<FieldValueBaseFragment>({
    fragment: FieldValueBase,
    fragmentName: 'FieldValueBase',
    ...options,
  });
};
  
        